import { Dropdown, Button, Tooltip, message } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import { exportarEntregasExcel } from "./EntregasExportarButton";
import { getInformeUnoaUno } from "../../../../services/financiero/finInformeUnoaUno";
import * as ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import dayjs from "dayjs";
import { useState } from "react";

export default function ExportarExcelDropdown({ data = [] }) {

  const [loading, setLoading] = useState(false);

  /* ---------------- EXPORTAR ENTREGAS ---------------- */

  const exportarEntregas = async () => {
    try {
      setLoading(true);
      await exportarEntregasExcel(data);
    } finally {
      setLoading(false);
    }
  };

  /* ---------------- EXPORTAR INFORME UNO A UNO ---------------- */

  const exportarInformeUnoAUno = async () => {

    try {

      setLoading(true);

      const res = await getInformeUnoaUno();
      const datos = res.data || [];

      if (!datos.length) {
        message.warning("No hay datos para exportar");
        return;
      }

      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Informe Uno a Uno");

      /* ---------- columnas ---------- */

      worksheet.columns = [

        { header: "Símbolo Proyecto", key: "simbolo", width: 18 },

        { header: "Participante / Organización", key: "nombre_entrega", width: 40 },

        { header: "Departamento", key: "departamento", width: 20 },

        { header: "Municipio", key: "municipio", width: 20 },

        { header: "Documento Identidad", key: "identificacion", width: 20 },

        { header: "Género", key: "sexo", width: 12 },

        { header: "# PO", key: "Numero_PO", width: 15 },

        { header: "ID Producto", key: "oid_producto", width: 12 },

        { header: "Nombre Producto", key: "nombre_producto", width: 45 },

        { header: "N° Acta Entrega", key: "carpeta", width: 25 },

        { header: "Responsable Recibo", key: "responsable", width: 25 },

        { header: "Cantidad", key: "cantidad", width: 12 },

        { header: "Precio Unitario (COP)", key: "valor_unitario_COP", width: 18 },

        { header: "Total Entrega (COP)", key: "precio_total_COP", width: 18 },

        { header: "Fecha Entrega", key: "fecha_entrega", width: 18 },

        { header: "Tipo Entrega", key: "tipo_entrega_texto", width: 18 },

        { header: "Categoría", key: "estado_soporte", width: 18 },

        { header: "Entrega CC/NIT", key: "EntregaCCNit", width: 15 },

        { header: "Código Proyecto", key: "codigo", width: 15 },

        { header: "Proyecto", key: "proyecto", width: 40 }

      ];

      /* ---------- estilos encabezado ---------- */

      const headerRow = worksheet.getRow(1);

      headerRow.eachCell((cell) => {

        cell.font = {
          bold: true,
          size: 11,
          color: { argb: "FFFFFFFF" }
        };

        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FF042956" }
        };

        cell.alignment = {
          horizontal: "center",
          vertical: "middle",
          wrapText: true
        };

        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" }
        };

      });

      /* ---------- agregar datos ---------- */

      datos.forEach(row => {

        worksheet.addRow({

          simbolo: "UTF/COL/160/COL",

          nombre_entrega: row.nombre_entrega,

          departamento: row.departamento || "",

          municipio: row.municipio || "",

          identificacion: row.identificacion,

          sexo: row.sexo || "N/A",

          Numero_PO: row.Numero_PO,

          oid_producto: row.oid_producto,

          nombre_producto: row.nombre_producto,

          carpeta: row.carpeta,

          responsable: row.responsable,

          cantidad: Number(row.cantidad),

          valor_unitario_COP: Number(row.valor_unitario_COP),

          precio_total_COP: Number(row.precio_total_COP),

          fecha_entrega: row.fecha_entrega
            ? dayjs(row.fecha_entrega).format("DD/MM/YYYY")
            : "",

          tipo_entrega_texto: row.tipo_entrega_texto,

          estado_soporte: row.estado_soporte,

          EntregaCCNit: row.EntregaCCNit,

          codigo: row.codigo,

          proyecto: row.proyecto

        });

      });

      /* ---------- estilos filas ---------- */

      worksheet.eachRow((row, rowNumber) => {

        if (rowNumber === 1) return;

        row.eachCell((cell, colNumber) => {

          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" }
          };

          cell.alignment = {
            vertical: "middle",
            horizontal:
              [6,7,8,12,13,14,15].includes(colNumber)
                ? "center"
                : "left"
          };

        });

      });

      /* ---------- formato pesos ---------- */

      worksheet.getColumn("valor_unitario_COP").numFmt = '"$"#,##0';
      worksheet.getColumn("precio_total_COP").numFmt = '"$"#,##0';

      /* ---------- congelar encabezado ---------- */

      worksheet.views = [
        { state: "frozen", ySplit: 1 }
      ];

      /* ---------- exportar ---------- */

      const buffer = await workbook.xlsx.writeBuffer();

      saveAs(
        new Blob([buffer]),
        `Informe_Uno_A_Uno_${dayjs().format("YYYYMMDD_HHmm")}.xlsx`
      );
    } catch (error) {
      console.error(error);
      message.error("Error generando informe");
    } finally {
      setLoading(false);
    }
  };

  const items = [
    {
      key: "1",
      label: "Exportar Entregas",
      onClick: exportarEntregas
    },
    {
      key: "2",
      label: "Exportar Informe Uno a Uno",
      onClick: exportarInformeUnoAUno
    }
  ];

  return (
    <Dropdown menu={{ items }} placement="bottomRight">
      <Tooltip title="Exportar reportes a Excel">
        <Button
          icon={<DownloadOutlined />}
          loading={loading}
        >
          Exportar
        </Button>
      </Tooltip>
    </Dropdown>
  );
}